<template>
    <div class="certif_commitments">
        <h2>{{ $t('certif.title') }}</h2>
        <div class="certif_logos">
             <picture class="certif_logo">
                <source :srcset="require('@/assets/certif/solutions-logistiques-entreprises.webp')" type='image/webp' />
                <img :src="require('@/assets/certif/solutions-logistiques-entreprises.png')" alt="Logo Coq Vert" loading="lazy" />
            </picture>
            <picture class="certif_logo">
                <source :srcset="require('@/assets/certif/gestion-stock-optimisation.webp')" type='image/webp' />
                <img :src="require('@/assets/certif/gestion-stock-optimisation.png')" alt="Logo BPI France" loading="lazy" />
            </picture>
            <picture class="certif_logo">
                <source :srcset="require('@/assets/certif/expert-stockage-solution.webp')" type='image/webp' />
                <img :src="require('@/assets/certif/expert-stockage-solution.png')" alt="Logo ICPE Installations Classéees pour la Protection de l'Environnement" loading="lazy" />
            </picture>
             <picture class="certif_logo">
                <source :srcset="require('@/assets/certif/stockage-marchandise-entrepot.webp')" type='image/webp' />
                <img :src="require('@/assets/certif/stockage-marchandise-entrepot.png')" alt="Logo AEO Opérateur Economique Agréé" loading="lazy" />
             </picture>
             <picture class="certif_logo">
                <source :srcset="require('@/assets/certif/service-livraison-rapide.webp')" type='image/webp' />
                <img :src="require('@/assets/certif/service-livraison-rapide.png')" alt="Logo Ecocert" loading="lazy" />
            </picture>
        </div>
    </div>
</template>

<style scoped>
.certif_commitments {
    margin-top: 100px;
}
.certif_logos {
    display: flex;
    justify-content: space-between;
    max-width: 1440px;
    margin: auto;
}
h2 {
    text-align: left;
    color: #e91e63;
    font-size: 45px;
    margin: 140px 30px;
    margin-bottom: 100px;
    text-align: center;
}
.certif_logo {
    width: 140px;
    height: auto;
}
.certif_logo > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
@media screen and (min-width: 2000px ) {
    .certif_logos {
        max-width: 1440px;
    }
}
@media screen and (max-width: 750px ) {
    h2 {
        margin-bottom: 50px;
        margin-top: 0;
        font-size: 37px;
    }
    .certif_logos {
        flex-direction: column;
        align-items: center;
    }
    .certif_logo {
        width: 110px;
    }
    .certif_commitments {
        margin-top: 20px;
    }

}
</style>